<template>
  <div>
    <b-sidebar id="sidebar" title="Settings" shadow right>
      <div style="text-align: left; margin: 1em">
        <b-button v-b-modal.range-aliases size="sm">Indicator Range Aliases</b-button>
        <br />
        <b-button class="mt-2" v-b-modal.edit-pair size="sm">Edit Sample Sets</b-button>
        <br />
        <b-button class="mt-2" v-b-modal.moonphase-icon-list size="sm">Moonphase List</b-button>

        <hr />
        <b-button size="sm" class="mt-2" @click="$bvModal.show('upload-excel-file')" v-if="isAdmin">Upload Data</b-button>
        <br />
        <b-button size="sm" class="mt-2" @click="$bvModal.show('upload-ranges')" v-if="isAdmin">Upload Range</b-button>
      </div>
    </b-sidebar>

    <b-modal id="range-aliases" centered hide-footer title="Indicator Range Aliases">
      <p>Local aliases allow you to use an exising range on another crop that does not have ranges.</p>
      <p>These aliases will be lost when you reload the page.</p>
      <b-form style="text-align: left" @submit.prevent="rangeAlias">
        <b-form-group label="Select Crop 'with ranges':">
          <b-select v-model="cropName" :options="rangeCrops"></b-select>
        </b-form-group>

        <b-form-group label="Alias Name 'crop without ranges':">
          <b-input required type="text" v-model="aliasName"></b-input>
        </b-form-group>
        <b-button type="submit">Save</b-button>
      </b-form>
    </b-modal>

    <pair-functions />

    <b-modal id="moonphase-icon-list" centered hide-footer title="Moonphase Icons">
      <b-table :fields="['phase', 'icon']" :items="iconItems">
        <template v-slot:cell(icon)="row">
          <svg width="50" height="50">
            <g :transform="`scale(.35)`" v-html="moonImages[row.item.phase]"></g>
          </svg>
        </template>
      </b-table>
    </b-modal>

    <upload-file />
    <upload-range />
  </div>
</template>

<script>
import { randomId } from "../modules/utils";
import { images } from "../modules/moonphase";
import PairFunctions from "./PairFunctions.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import UploadFile from "./UploadFile.vue";
import UploadRange from "./UploadRange.vue";

export default {
  name: "settings",
  components: {
    PairFunctions,
    UploadFile,
    UploadRange,
  },
  data() {
    return {
      aliasName: "",
      cropName: "",
      iconItems: [
        { phase: "New" },
        { phase: "Waxing Crescent" },
        { phase: "First Quarter" },
        { phase: "Waxing Gibbous" },
        { phase: "Full" },
        { phase: "Waning Gibbous" },
        { phase: "Last Quarter" },
        { phase: "Waning Crescent" },
      ],
    };
  },
  methods: {
    rangeAlias() {
      if (this.rangeCrops.includes(this.aliasName)) {
        return this.notify({
          message: "That alias already exists.",
          variant: "warn",
        });
      }
      this.setAliases([{ aliasName: this.aliasName, cropName: this.cropName, id: randomId() }]);
      this.$bvModal.hide("range-aliases");
    },
    ...mapMutations(["setAliases"]),
    ...mapActions(["notify"]),
  },
  computed: {
    moonImages() {
      return images;
    },
    rangeCrops() {
      return this.getRanges.map(x => x.cropName);
    },
    ...mapGetters(["getRanges", "getRangeBooks", "isAdmin"]),
  },
};
</script>

<style lang="scss" scoped>
</style>